import { render, staticRenderFns } from "./XeroRegistration.vue?vue&type=template&id=46cdd256&scoped=true&"
import script from "./XeroRegistration.vue?vue&type=script&lang=js&"
export * from "./XeroRegistration.vue?vue&type=script&lang=js&"
import style0 from "./XeroRegistration.vue?vue&type=style&index=0&id=46cdd256&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cdd256",
  null
  
)

export default component.exports